import React, { useState, useEffect, useRef } from 'react'
import { Form, Input, Button, Col, Row, Modal, Table, Tag, Select, Radio, Spin } from 'antd'
import { useImmer } from "use-immer"
import { CheckCircleOutlined, CheckCircleFilled, CheckOutlined } from '@ant-design/icons'
import Upgrade from './upgrade'
import UserModal from './userModal'
import './index.css'

import FullHeightModal from "../../Common/components/FullHeightModal"
import { useSelector, useDispatch } from 'react-redux'
import PricingTable from './planDetails.tsx'
import { track } from 'statsig'
import { STATSIG, PAGE } from 'statsig/events'

export default function PlanPricing(props) {
    const dispatch = useDispatch()
    // 不再依赖 Redux 中的 subscription 数据，每次都从服务器获取最新数据
    const { open } = useSelector(state => {
        return state.manager
    })
    const { invite } = props

    const refPlanDetailsTable = useRef();
    const [chosenPlan, setChosenPlan] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isUserModalOpen, setIsUserModalOpen] = useState(false)
    const [isPlanModalOpen, setPlanIsModalOpen] = useState(false)
    const [isSupportModalOpen, setSupportModalOpen] = useState(false)
    const [messageReceivedModalOpen, setMessageReceivedModalOpen] = useState(false)
    const [isUpgrade, setIsUpgrade] = useState(false)
    const [checkUser, setCheckUser] = useState([])
    const [inviteStatus, setInviteStatus] = useState(false)
    const [loading, setLoading] = useState(false)
    const [form] = Form.useForm()
    const tableRef = useRef(null)
    const { TextArea } = Input
    const pricingContent = [
        {
            title: "Explorer",
            planType: "starter",
            price: 'FREE',
            date: "per month",
            period: 'forever',
            button: 'Get Started Free',
            details: [
                // 'Unlimited Price Engine requests',
                // '5 Strata AI queries per day',
                // '2 Digital 1003 exports per month',
                // '2 MISMO 3.4 exports per month',
                // 'Credit pull integration',
                // 'Agent personal webpage',
                // 'Rate & Affordability Calculator widget',
                // 'Document AI Processing'
                'FNM / 1003 exports (10 lifetime)',
                'Strata AI (10 per day)',
                'Personal website',
                'Pricing engine',
                'Mortgage call reports',
                'AI tools (Income, Document Review, Conditions)',
            ]

        },
        {
            title: "Individual",
            planType: "originator",
            price: '$8',
            date: "per user/month",
            button: 'Upgrade',
            period: '/mo per user',
            details: [
                // 'Unlimited Price Engine requests',
                // 'Unlimited Strata AI queries',
                // 'Unlimited 1003 PDF exports',
                // 'Unlimited MISMO 3.4 exports',
                // 'Credit pull integration',
                // 'Agent personal webpage & customized url',
                // 'Rate & Affordability Calculator widget',
                // 'Document AI Processing'
                'Everything in Explorer',
                'Unlimited FNM / 1003 exports',
                'Unlimited Strata AI',
                'Whitelabeled personal website',
                'OpenHouse Finder',
                'Rate Marketplace'

            ]

        },
        {
            title: "Business",
            planType: "business",
            price: '$35',
            date: "per company/month",
            button: 'Upgrade',
            period: '/mo per company',
            details: [
                // 'Unlimited Price Engine requests',
                // 'Unlimited Strata AI queries',
                // 'Unlimited 1003 PDF exports',
                // 'Unlimited MISMO 3.4 exports',
                // 'Credit pull integration',
                // 'Agent personal webpage & customized url',
                // 'Rate & Affordability Calculator widget',
                // 'Document AI Processing',
                // 'Team & Branch Setup'
                'Everything in Originator',
                'APIs & LOS/CRM integrations',
                'Dedicated AE',
                // 'Homeowner & OpenHouse Marketplaces'

            ]

        },
        // {
        //     title: "Enterprise",
        //     planType: "enterprise",
        //     price: 'LET\'S TALK',
        //     date: "per month",
        //     button: 'Contact us',
        //     details: [
        //         'Fully customizable solutions',
        //         'Dedicated Solution Engineers',
        //         'Dedicated Customer Support',
        //         "Dedicated Account Executives"
        //     ]

        // },



    ]

    const catStyle = {
        color: '#1F2890',
        fontWeight: 'bold',
        fontSize: '20px',
        width: '100%'
    }
    const dataSource = [
        {
            title: (<div className='UserSource' style={catStyle}>Basic</div>),
            Starter: false,
            Business: false,
            Originator: false,
            Enterprise: false,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Cross Platform</div>),
            Starter: true,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Agent Webpage</div>),
            Starter: true,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Customized Web Page URL</div>),
            Starter: false,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Team & Branch Setup</div>),
            Starter: false,
            Originator: false,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={catStyle}>Pricing Engine</div>),
            Starter: false,
            Originator: false,
            Business: false,
            Enterprise: false,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Requests</div>),
            Starter: 'Unlimited',
            Business: "Unlimited",
            Originator: "Unlimited",
            Enterprise: "Unlimited",
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Add Wholesale Lenders</div>),
            Starter: 'Unlimited',
            Business: "Unlimited",
            Originator: "Unlimited",
            Enterprise: "Unlimited",
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}> Borrower Rate Pricer</div>),
            Starter: true,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Affordability Calculator</div>),
            Starter: true,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}> Compensation Editor</div>),
            Starter: true,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>  Overlay Editor</div>),
            Starter: false,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}> Plug-in and Widgets</div>),
            Starter: false,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Automated Pre-Qual System</div>),
            Starter: true,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Automated Soft Credit Pulls</div>),
            Starter: false,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Automated Liability Review</div>),
            Starter: false,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={catStyle}>Loan Origination System</div>),
            Starter: false,
            Originator: false,
            Business: false,
            Enterprise: false,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>MISMO 3.4 Export</div>),
            Starter: "2/month",
            Originator: "2/month",
            Business: "2/month",
            Enterprise: "Unlimited",
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Document Management</div>),
            Starter: true,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Email Communication System</div>),
            Starter: true,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Unlimited File Storage</div>),
            Starter: true,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>AI Document Auto Processing</div>),
            Starter: false,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={catStyle}>Strata AI</div>),
            Starter: '10 queries/day',
            Originator: 'Unlimited',
            Business: "Unlimited",
            Enterprise: "Unlimited",
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Q&A</div>),
            Starter: false,
            Originator: "Unlimited",
            Business: "Unlimited",
            Enterprise: "Unlimited",
        },
        {
            title: (<div className='UserSource' style={catStyle}>Help Center</div>),
            Starter: false,
            Originator: false,
            Business: false,
            Enterprise: false,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}>Dedicated Support</div>),
            Starter: false,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}> Rest APIs</div>),
            Starter: false,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}> Modular Solutions</div>),
            Starter: false,
            Originator: true,
            Business: true,
            Enterprise: true,
        },
        {
            title: (<div className='UserSource' style={{ fontWeight: 'bold' }}> Full Customization Solution</div>),
            Starter: false,
            Originator: false,
            Business: false,
            Enterprise: true,
        },

    ]
    const [currentInfo, setCurrentInfo] = useState({ loanOfficers: [] })
    const beginUpgrade = (planKey) => {
        const plan = planKey === 'business' ? 'business' : 'individual'
        track(STATSIG.PAYMENT.PLAN, plan, { plan })
        setChosenPlan(planKey)
        setIsUpgrade(true)
    }
    const [showUserSelection, setShowUserSelection] = useState(false);
    useEffect(() => {
        track(STATSIG.COMMON.VIEW, PAGE.PLANS_AND_PRICING, { page: PAGE.PLANS_AND_PRICING })
        // 每次进入页面都从服务器获取最新数据
        getcurrentsubscription()
    }, [])

    const getcurrentsubscription = async () => {
        setLoading(true)
        
        // 直接从服务器获取最新数据
        let token = sessionStorage.getItem("ZeitroA")
        const response = await fetch('/los/getcurrentsubscription', {
            method: 'get',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        })
        const DataInfo = await response.json()
        const { customerID, loanOfficers, plan, stripeCustomer, recurringInterval } = DataInfo
        
        console.log('getcurrentsubscription - 从服务器获取的 loanOfficers:', loanOfficers)
        console.log('getcurrentsubscription - 过滤后的 loanOfficers:', loanOfficers?.filter(e => e.Status !== "disabled"))

        // 更新 Redux 状态
        dispatch({ type: "SUBSCRIPTION_INFO", data: { ...DataInfo, loading: false } })

        setCurrentInfo({
            customerID,
            loanOfficers: loanOfficers?.filter(e => e.Status !== "disabled"),
            plan,
            stripeCustomer,
            recurringInterval
        })
        setCheckUser(loanOfficers?.filter(e => e.Status !== "disabled"))
        setTimeout(() => {
            setLoading(false)
            setIsUpgrade(false)
            setChosenPlan(null)
        }, 500)
    }
    const columns = [
        {
            title: '',
            dataIndex: 'title',
            width: 20,
            ellipsis: true,
            key: 'title',
        },
        {
            title: <div className='plan-table-header'>Starter</div>,
            dataIndex: 'Starter',
            align: 'center',
            key: 'Starter',
            width: '60px',
            render: (text) => <>{typeof text === 'string' ? <span style={{ color: "#1F2890", fontSize: '16px', fontWeight: '600' }}>{text}</span> : text ? <img src='/images/plan-check.svg' /> : <></>}</>,

        },
        {
            align: 'center',
            title: <div className='plan-table-header'>Originator</div>,
            width: '60px',
            dataIndex: 'Originator',
            key: 'Originator',
            render: (text) => <>{typeof text === 'string' ? <span style={{ color: "#1F2890", fontSize: '16px', fontWeight: '600' }}>{text}</span> : text ? <img src='/images/plan-check.svg' /> : <></>}</>,

        },
        {
            align: 'center',
            title: <div className='plan-table-header'>Business</div>,
            width: '60px',
            dataIndex: 'Business',
            key: 'Business',
            render: (text) => <>{typeof text === 'string' ? <span style={{ color: "#1F2890", fontSize: '16px', fontWeight: '600' }}>{text}</span> : text ? <img src='/images/plan-check.svg' /> : <></>}</>,

        },
        {
            title: <div className='plan-table-header'>Enterprise </div>,
            align: 'center',
            width: '60px',
            dataIndex: 'Enterprise',
            key: 'Enterprise',
            render: (text) => <>{typeof text === 'string' ? <span style={{ color: "#1F2890", fontSize: '16px', fontWeight: '600' }}>{text}</span> : text ? <img src='/images/plan-check.svg' /> : <></>}</>,

        },


    ]
    const validateMessages = {
        required: '${label} is required!',
        types: {
            email: '${label} is not a valid email!',
        }
    }
    async function getPlans() {
        let token = sessionStorage.getItem("ZeitroA")
        setLoading(true)
        const response = await fetch('/los/getcurrentsubscription', {
            method: 'get',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        })
        const DataInfo = await response.json()
        const { customerID, loanOfficers, plan, stripeCustomer, recurringInterval } = DataInfo
        dispatch({ type: "SUBSCRIPTION_INFO", data: { ...DataInfo, loading: true } })
        setCurrentInfo({
            customerID,
            loanOfficers,
            plan,
            stripeCustomer,
            recurringInterval
        })
        setLoading(false)

    }

    const scrollToTop = () => {
        const tableContainer = refPlanDetailsTable.current?.querySelector('.ant-table-body')
        tableContainer && tableContainer.scrollTo({ top: 0, behavior: "smooth" });
    }

    const currentPlan = () => {
        return (
            <div className='current-plan'>
                current plan
            </div>
        )
    }

    return (
        <>
            <div className='mx-3'>

                <div className='plans-top-bar'>
                    <div className='plans-title'>
                        Plans and Pricing
                    </div>
                    <Button className='plans-support-btn' onClick={() => {
                        setSupportModalOpen(true)
                    }}>Support</Button>
                </div>

                {!isUpgrade && currentInfo.plan === 'enterprise' && 
                <div className='pricing-footer'>
                    <div className='pricing-footer-item' style={{ display: 'flex', justifyContent: 'space-between', padding: 24 }}>
                        <div className='pricing-footer-item-content'>
                            <div className='pricing-footer-item-title' style={{display: 'flex'}}>Enterprise <div style={{marginLeft: 12}}>{currentPlan()}</div></div>
                            <div className='pricing-footer-item-subtitle'>Talk to us</div>
                            <div className='pricing-footer-item-description'>Fully customizable digital solutions powering the industry leaders.</div>
                        </div>
                        {/* <div className='pricing-footer-item-button-box'>
                            <div className='pricing-footer-item-button' onClick={() => {
                                window.open('https://www.zeitro.com/demo', '_blank')
                            }}>Schedule demo</div>
                        </div> */}
                    </div>
                </div>
                }

                <Spin spinning={loading}>
                    <div className='pricingContent'>
                        {isUpgrade ? (
                            <Upgrade 
                                back={() => {
                                    setIsUpgrade(false)
                                    // setShowUserSelection(true)
                                    // getPlans()
                                    getcurrentsubscription()
                                    setChosenPlan(null)
                                }} 
                                loanOfficers={checkUser} 
                                stripeCustomer={currentInfo.stripeCustomer} 
                                userNumber={currentInfo.loanOfficers.length}
                                onBackToUserSelection={() => {
                                    setIsUpgrade(false)
                                    setShowUserSelection(true)
                                    setChosenPlan(null)
                                }}
                                chosenPlan={chosenPlan}
                                invite={props.invite}
                                currentPlan={currentInfo.plan}
                                recurringInterval={currentInfo.recurringInterval}
                            />
                        ) : showUserSelection ? (
                            <UserModal 
                                isModalOpen={true} 
                                loanOfficers={currentInfo.loanOfficers} 
                                closeModal={(selectedUsers) => {
                                    if (selectedUsers) {
                                        setCheckUser(selectedUsers)
                                        setIsUpgrade(true)
                                        setChosenPlan("business")
                                    }
                                    setShowUserSelection(false)
                                }}
                            />
                        ) : <Row gutter={12} className='price'>
                            {pricingContent.map((item, index) => {

                                return (
                                    // <Col lg={{ span: 6, offset: index > 0 ? 2 : 1 }}>
                                    <Col xl={8} span={24}>
                                        <div className={currentInfo.plan === item.planType.toLocaleLowerCase() ? 'pricingBlock chosen' : 'pricingBlock'}>
                                            <div>
                                                <div style={{ display: "flex", justifyContent: "end" }}>
                                                    {/* {currentInfo.plan === item.title.toLocaleLowerCase() ? <CheckCircleFilled style={{ fontSize: "20px", color: "#325CE9" }} /> : <div className='circle'></div>
                                                    } */}
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className='pricingTitle'>{item.title}</div>
                                                    {currentInfo.plan === item.planType.toLocaleLowerCase() ? <div>{currentPlan()}</div> : ''}
                                                </div>
                                                <div className='pricingPrice'>{item.price}{item.period && <span className='pricingPrice-unit'>{item.period}</span>}</div>
                                                {/* <div style={{marginTop: 5, height: 43, color: '#474849', fontSize: 12}}>{(index === 1 || index === 2) && <span>{item.date}</span>}</div> */}
                                                {item.planType === 'business' && <div className="pricingDetails-users">up to 30 users</div>}
                                                <div className="pricingDetails-line"></div>

                                                <div className='scroll'>      
                                                    {item.details.map(item => {
                                                        return (
                                                            <div className='pricingDetails'>
                                                                {/* <img src='/images/plan-checkCircle.svg' /> */}
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.6529 6.34713C20.1157 6.80998 20.1157 7.56039 19.6529 8.02324L9.92593 17.7502L4.34713 12.1714C3.88429 11.7085 3.88429 10.9581 4.34713 10.4953C4.80998 10.0324 5.56039 10.0324 6.02324 10.4953L9.92593 14.398L17.9768 6.34713C18.4396 5.88429 19.19 5.88429 19.6529 6.34713Z" fill="#2E605A"/>
                                                                </svg>
                                                                <div title={item} style={{ color: '#222', lineHeight: 'normal' }} className='pricingDetailsCon'>{item}</div>
                                                            </div>

                                                        )
                                                    })}
                                                </div>

                                                {index === 2 && 
                                                    <>
                                                        <div className="pricingDetails-line"></div>
                                                        <div className="pricingDetails-users-add">
                                                            <span className="pricingDetails-users-title">Add additional users</span>
                                                            <span className="pricingDetails-users-price">+ $8<span className="pricingDetails-users-price-unit">/mo</span></span>
                                                        </div>
                                                    </>
                                                }

                                            </div>
                                            <div>
                                            {index === 1 && currentInfo.plan === 'starter' &&
                                                    <div style={{ padding: '0 30px 0 18px', display: 'flex', justifyContent: 'center' }}>
                                                        <Button type='primary' className='plan-main-btn' style={{ width: '100%', height: '44px' }} onClick={() => {
                                                                beginUpgrade('originator')
                                                                dispatch({ type: "SHOW_PRICiNG", data: false })
                                                                dispatch({ type: "STEP", data: 1 })
                                                                               
                                                        }}>{item.button}</Button>
                                                    </div>
                                                }
                                                {index === 2 &&
                                                    <div style={{ padding: '0 30px 0 18px', display: 'flex', justifyContent: 'center' }}>
                                                        {currentInfo.plan === 'originator' ? 
                                                        // <Button className='plan-contact-btn' style={{ width: '100%', height: '44px', marginTop: '20px' }} onClick={() => {
                                                        //     if (index === 2) {
                                                        //         setSupportModalOpen(true)

                                                        //     }
                                                        // }}>
                                                        //     Contact us
                                                        // </Button> :
                                                        // 支持从 Originator 升级到 Business
                                                        <Button className='plan-main-btn' style={{ width: '100%', height: '44px', marginTop: '20px' }} onClick={() => {
                                                            beginUpgrade('business')
                                                        }}>
                                                            Upgrade
                                                        </Button> :
                                                        
                                                        currentInfo.plan !== 'enterprise' && <Button type='primary' className='plan-main-btn' style={{ width: '100%', height: '44px' }} onClick={() => {
                                                            if (open) {
                                                                if (currentInfo.plan !== 'business') {
                                                                    // 直接执行 Proceed to upgrade 的逻辑，不打开弹窗
                                                                    // if (currentInfo.loanOfficers.length > 1) {
                                                                    //     setIsUserModalOpen(true)
                                                                    // } else {
                                                                        beginUpgrade('business')
                                                                    // }
                                                                    return
                                                                }
                                                                setChosenPlan('business')
                                                                dispatch({ type: "SHOW_PRICiNG", data: false })
                                                                dispatch({ type: "STEP", data: 1 })
                                                                return

                                                            }
                                                            if (currentInfo.plan !== 'starter') {
                                                                invite(false)
                                                                return
                                                            }
                                                            // if (currentInfo.loanOfficers.length > 1) {
                                                            //     setIsUserModalOpen(true)
                                                            //     return
                                                            // }
                                                            if (index === 2) {
                                                                if (inviteStatus) {
                                                                    // if (currentInfo?.loanOfficers.length > 1) {
                                                                    //     setIsUserModalOpen(true)
                                                                    // } else {
                                                                        beginUpgrade('business')
                                                                        setIsModalOpen(false)
                                                                    // }
                                                                } else {
                                                                    beginUpgrade('business')
                                                                }
                                                            }


                                                        }}>{currentInfo.plan !== 'business' ? item.button : 'Manage'}</Button>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    index === 3 && (
                                                        <div style={{ padding: '0 30px 0 18px' }}>
                                                            <Button className='plan-contact-btn' style={{ width: '100%', height: '44px', marginTop: '20px' }} onClick={() => {
                                                                // if (index === 2) {
                                                                    setSupportModalOpen(true)

                                                                // }
                                                            }}>
                                                                Contact us
                                                            </Button>
                                                        </div>
                                                    )
                                                }
                                                <div style={{ color: '#325CEB', fontWeight: 600, lineHeight: '24px', textAlign: 'center', marginTop: 12, paddingRight: 12 }}><span style={{ cursor: 'pointer' }} onClick={() => {
                                                    const plan = item.title.toLowerCase()
                                                    track(STATSIG.PAYMENT.PLAN_DETAILS, plan, { plan })
                                                    setPlanIsModalOpen(true)
                                                }}>Plan details</span></div>

                                            </div>
                                        </div>
                                    </Col>

                                )

                            })
                            }


                        </Row>
                        }
                    </div>
                </Spin>


                {!isUpgrade && <div className='pricing-footer'>
                    {currentInfo.plan !== 'enterprise' && 
                        <div className='pricing-footer-item' style={{ display: 'flex', justifyContent: 'space-between', padding: 24 }}>
                            <div className='pricing-footer-item-content'>
                                <div className='pricing-footer-item-title'>Enterprise</div>
                                <div className='pricing-footer-item-subtitle'>Talk to us</div>
                                <div className='pricing-footer-item-description'>Fully customizable digital solutions powering the industry leaders.</div>
                            </div>
                            <div className='pricing-footer-item-button-box'>
                                <div className='pricing-footer-item-button' onClick={() => {
                                    track(STATSIG.PAYMENT.SCHEDULE_DEMO, 'enterprise', { source: 'enterprise' })
                                    window.open('https://www.zeitro.com/demo', '_blank')
                                }}>Schedule demo</div>
                            </div>
                        </div>
                    }
                    <div className='pricing-footer-item' style={{ display: 'flex', justifyContent: 'space-between', padding: 24 }}>
                        <div className='pricing-footer-item-content'>
                            <div className='pricing-footer-item-title'>Loan Product Listing </div>
                            <div className='pricing-footer-item-subtitle'>Talk to us</div>
                            <div className='pricing-footer-item-description'>AI-powered product listings, live in seconds and marketed to loan officers nationwide.</div>
                        </div>
                        <div className='pricing-footer-item-button-box'>
                            <div className='pricing-footer-item-button' onClick={() => {
                                track(STATSIG.PAYMENT.SCHEDULE_DEMO, 'loan_product', { source: 'loan_product' })
                                window.open('https://www.zeitro.com/demo', '_blank')
                            }}>Schedule demo</div>
                        </div>
                    </div>
                </div>}
                
                <Modal open={isModalOpen} footer={null} onCancel={() => {
                    setIsModalOpen(false)
                }}>
                    <div style={{ textAlign: 'center', marginTop: '80px', fontSize: '18px', fontWeight: '600' }}>
                        <img src='/images/email.svg'></img>

                        <p>Before we upgrade you to the Zeitro Business Plan,</p>
                        <p>would you like to invite other team members to join?</p>

                    </div>
                    <div style={{ textAlign: 'center', marginBottom: '80px', marginTop: '60px', }}>
                        <Button className='ant-btn-default-zeitro' style={{ height: '44px' }} onClick={() => {
                            if (currentInfo.loanOfficers.length > 1) {

                                setIsUserModalOpen(true)
                            } else {
                                beginUpgrade('business')
                                setIsModalOpen(false)
                            }
                            setInviteStatus(true)

                        }}>Proceed to upgrade</Button>
                        <Button style={{ width: '40%', marginLeft: '10px', height: '44px' }} type='primary' onClick={() => {
                            if (open) {

                                dispatch({ type: "SHOW_PRICiNG", data: false })
                                dispatch({ type: "STEP", data: 1 })
                                return

                            }
                            invite(true)

                        }}>Invite user</Button>

                    </div>

                </Modal>
                <Modal 
                    width={786}
                    className='help-modal'
                    open={isSupportModalOpen} 
                    footer={null} 
                    onCancel={() => {
                        setSupportModalOpen(false)
                    }}>
                    <div className='help-modal-content'>
                        <div className='help-modal-content-title'>How can we help?</div>
                        <div className='help-modal-content-tips'>For inquiries regarding billing, payments, product feedback, or any issues encountered while using Zeitro, we're here to assist you promptly. </div>

                        <Form
                            className='help-modal-form'
                            onFinish={onFinish}
                            form={form}
                            style={{ marginTop: '20px', }}
                            layout='vertical'
                            validateMessages={validateMessages}

                        >
                            <Row>
                                <Col span={24}>
                                    <Form.Item
                                        className='help-modal-form-item'
                                        name="message"
                                        label="Message"
                                    >
                                        <TextArea
                                            className='help-modal-form-item-textarea'
                                            placeholder="Please leave us a message..." 
                                            style={{ 
                                                height: '250px',
                                                resize: 'none'
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                                <div style={{fontFamily: 'Inter', color: '#6E6E70', width: '100%', textAlign: 'center', marginTop: 20, lineHeight: '20px', letterSpacing: '0.2px'}}>Alternatively, you could also email us at <span style={{color: '#325CEB'}}>support@zeitro.com</span></div>
                            </Row>

                            <div style={{width: '100%', display: 'flex', justifyContent: 'center', gap: '48px'}}>
                                <Button className='help-modal-btn cancel-btn' onClick={() => {
                                    setSupportModalOpen(false)

                                }}>Cancel</Button>
                                <Button className='help-modal-btn send-btn' type='primary' htmlType="submit">Send Message</Button>

                            </div>
                        </Form>
                    </div>


                </Modal>

                <FullHeightModal open={isPlanModalOpen} width={1280} footer={null} onClose={() => {
                    setPlanIsModalOpen(false)
                }}
                    content={<>
                        <PricingTable />
                        </>}>

                </FullHeightModal>
                <Modal open={messageReceivedModalOpen} footer={null} onCancel={() => {
                    setMessageReceivedModalOpen(false)
                }}>
                    <div className='text-center p-5'>
                        <div><img src='/images/emailSent.svg' /></div>
                        <div className='User_modal_title my-3'>We've received your message</div>
                        <div className='title-5 text-center'>Thank you for reaching out. </div>
                        <div className='title-5 text-center'>We will get back to you via email as soon as possible.</div>
                        <Button type='primary' size='large' className='mt-4' onClick={() => setMessageReceivedModalOpen(false)}>Done</Button>
                    </div>
                </Modal>
                <UserModal isModalOpen={isUserModalOpen} loanOfficers={currentInfo.loanOfficers} closeModal={(e) => {
                    if (!e) {
                        setIsUserModalOpen(false)
                        return
                    }
                    setCheckUser(e)
                    setIsModalOpen(false)
                    beginUpgrade('business')
                    setIsUserModalOpen(false)

                }}></UserModal>
            </div>

        </>
    )
    function onFinish(val) {
        let token = sessionStorage.getItem("ZeitroA")
        fetch('/los/customersupporttoslack', {
            method: 'POST',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
            body: JSON.stringify({
                Message: val.message
            })
        }).then(async response => {
            if (!response.ok) {
                return
            }
        })
        setSupportModalOpen(false)
        setMessageReceivedModalOpen(true)
    }
}
